import type { ExcalidrawElement } from '@excalidraw/excalidraw/element/types';
import { z } from 'zod';
import { templateBaseSchema } from './base';

export const templateImageSchema = templateBaseSchema.extend({
  type: z.literal('image'),
  name: z.string(),
  showTitle: z.boolean(),
  canEditImage: z.boolean().optional(),
  // excalidraw schema
  annotator: z
    .array(
      z.custom<ExcalidrawElement>((val) => {
        const isExcalidrawElement = (element: unknown) => {
          if (
            typeof element !== 'object' ||
            element === null ||
            !('type' in element)
          ) {
            return false;
          }

          const type = element.type;
          switch (type) {
            case 'text':
            case 'diamond':
            case 'rectangle':
            case 'iframe':
            case 'embeddable':
            case 'ellipse':
            case 'arrow':
            case 'freedraw':
            case 'line':
            case 'frame':
            case 'magicframe':
            case 'image':
            case 'selection': {
              return true;
            }
            default: {
              return false;
            }
          }
        };

        return isExcalidrawElement(val);
      }),
    )
    .optional(),
  // save to DB will have
  fileId: z.string().optional(),
  // local
  file: z.file().optional(),
  uploadedToGallery: z.boolean(),
});

export type TemplateImageV1 = z.infer<typeof templateImageSchema>;
